'use client'
import Link from 'next/link';

import styles from './partner.module.css'
import Image from 'next/image';

export type PartnerProps = {
  logo: string,
  name: string
  url: string,
}

export const Partner = ({ logo, url, name }: PartnerProps ) => {

  return url ? (
    <Link href={url} target='_blank' rel='nofollow' className={styles.wrapper}>
      <Image src={logo || '/api.svg'} alt={name} width={60} height={60} unoptimized={(logo || '/api.svg').endsWith('svg')}/>
    </Link>
  ) : (
    <span className={styles.wrapper}>
      <Image src={logo || '/api.svg'} alt={name} width={60} height={60} unoptimized={(logo || '/api.svg').endsWith('svg')}/>
    </span>
  )
}
